import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useRootSelector } from '../../../../store/hooks';
import { selectCoursePricing } from '../../../../store/features/coursePricing';
import { SiteBuilderModule } from '../sharedComponents';
import { CourseOptionDisplayModuleSection } from './types';
import { CourseOptionDisplayModuleContextProvider } from './context';
import { ModuleWrapper } from './styledComponents';
import { DefaultDisplayStyle } from './displayStyles';

export type CourseOptionDisplayModuleProps = {
  section: CourseOptionDisplayModuleSection;
};

export default function CourseOptionDisplayModule(
  props: CourseOptionDisplayModuleProps,
) {
  const { section } = props;
  const coursePricing = useRootSelector(selectCoursePricing);
  const themeConfig = useContext(ThemeContext);

  if (!section.shown || !coursePricing.loaded) {
    return null;
  }

  const { courseOptionDisplayModule } = themeConfig.siteBuilderModules;
  const dStyles = courseOptionDisplayModule.displayStyles.DEFAULT;
  const vStyles = courseOptionDisplayModule.visualStyles.DEFAULT;

  return (
    <SiteBuilderModule section={section} moduleTheme={{ dStyles, vStyles }}>
      <ModuleWrapper
        data-testid="course-option-display-module-wrapper"
        className="c-course-option-display-module"
      >
        <CourseOptionDisplayModuleContextProvider section={section}>
          <DefaultDisplayStyle />
        </CourseOptionDisplayModuleContextProvider>
      </ModuleWrapper>
    </SiteBuilderModule>
  );
}
